// Hook for handling Correspondence

import { useMultiSiteContext } from "@hooks/use-site-context";
import { useUserContext } from "@hooks/use-auth-context";
import { fetchWithTokenRefresh } from "@hooks/shared/fetch-with-token-refresh";
import { useRefreshTokenMutation } from "@hooks/use-refresh-token-mutation";

export const useCorrespondenceContext = () => {
  const { getApiUrl } = useMultiSiteContext();
  const { user } = useUserContext();
  const { refreshUserToken } = useRefreshTokenMutation();

  const createCorrespondenceNote = async (ticketId: number, body: Record<string, any>) => {
    const endpoint = `wp-json/smapp/v1/ticket/${ticketId}/notes`;
    const url = getApiUrl(endpoint);

    try {
      const res = await fetchWithTokenRefresh(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.authToken ?? ""}`,
          },
          body: JSON.stringify(body),
        },
        () => refreshUserToken(user?.refreshToken ?? "")
      );
      return await res.json();
    } catch (err) {
      console.error("Failed to submit correspondence note:", err);
    }
  };

  return {
    createCorrespondenceNote,
  };
};
